<div class="ui basic segment">
  <div *ngIf="success || error">
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
    <esl-message-toast [(message)]="error"></esl-message-toast>
  </div>
  <div style="margin: -10px -30px" class="ui vertical basic segment">
    <app-advanced-search-filter
      (onDisplayRows)="displayRecords($event)"
      (onSearch)="searchRecords($event)"
      [hasAdvancedSearch]="true"
      [headers]="headers"
      [headerFilters]="headerFilters"
      [hasFilters]="true"
      (onSort)="sortRecords($event)"
      [searchFilters]="searchFilter"
      (advancedSearch)="advancedSearch($event)"
      (cancelAd)="cancelAd()"
    ></app-advanced-search-filter>
  </div>
  <div
    style="margin: -10px -30px"
    class="ui vertical basic segment"
    [ngClass]="{ loading: pending }"
  >
    <div
      fxLayout="row"
      tamsyMargin
      class="ui segment"
      marginB="3"
      fxLayoutGap="10px"
      fxLayoutAlign="start stretch"
      id="dark"
    >
      <div fxFlex="15%">IP Address</div>
      <div fxFlex="15%">Agent Name</div>
      <div fxFlex="40%">Username</div>
      <div style="position: relative; left: 3.7rem" fxFlex="20%">
        Email Address
      </div>
      <div style="position: relative; left: 3.2rem" fxFlex="20%">
        Last Country
      </div>
      <div fxFlex></div>
    </div>
    <ng-container *ngFor="let user of users">
      <div
        class="ui segment"
        appMargin
        marginB="3"
        fxLayout="row"
        fxLayoutGap="10px"
        fxLayoutAlign="start stretch"
      >
        <div fxFlex="15%">{{ user?.metadata?.lastIp || "--" }}</div>
        <div fxFlex="15%">{{ user?.metadata?.lastAgent || "---" }}</div>
        <div fxFlex="30%">{{ user?.user?.username }}</div>
        <div fxFlex="20%">
          {{ user?.user?.appUserEmail }}
        </div>
        <div fxFlex="20%" fxFlex>
          {{ user?.metadata?.lastCountry || "---" }}
        </div>
        <div fxFlex>
          <div class="ui basic dropdown custom-dropdown" suiDropdown>
            <div class="text">Actions</div>
            <div class="vertical-divider"></div>
            <div class="dropdown-icon">
              <i class="dropdown icon"></i>
            </div>
            <div class="left menu primary" suiDropdownMenu>
              <div (click)="assignGeofenceProfile(user)" class="item primary">
                Assign Geofence Profile
              </div>
              <div (click)="viewUser(user)" class="item primary">
                View User Details
              </div>
              <div (click)="onCreateLogAlertModal(user)" class="item primary">
                Create Alerts
              </div>
              <div (click)="assignRateLimitProfile(user)" class="item primary">
                Assign Rate Limit Profile
              </div>
              <div (click)="blacklistUser(user)" class="item primary">
                Blacklist User
              </div>
            </div>
          </div>
        </div>
        <!-- <div fxFlex  class="text-right">
                <button class="ui circular tiny button" (click)="onDelete.emit(user)"><i class="trash icon"></i></button>
                <a class="ui circular tiny button" routerLink="/admin/setting/user/detail/{{user.id}}"><i class="eye icon"></i></a>
            </div> -->
      </div>
    </ng-container>
    <app-no-record-found
      *ngIf="users && users.length < 1"
    ></app-no-record-found>

    <div class="ui vertical basic segment">
      <div class="ui two column grid">
        <div class="column middle aligned">
          <div class="ui icon small button">
            <i class="database icon"></i>
          </div>
          <a class="ui basic label">{{ totalItems }} Record(s)</a>
        </div>
        <div
          class="column right aligned pagination menu"
          style="margin-left: auto; margin-top: -60px"
        >
          <sui-pagination
            class="small"
            [collectionSize]="totalItems"
            [pageSize]="rows"
            [maxSize]="maxSize"
            [hasEllipses]="false"
            [page]="currentPage"
            (pageChange)="nextPage($event)"
          >
          </sui-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
